import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const statuses = ["Answer Acknowledged", "Answered Differently", "Withdrawn With Gratitude"];

export default function AnsweredRegister() {
  const [prayers, setPrayers] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    const params = {};
    if (q) params.q = q;
    if (status) params.status = status;
    api.get("/answered", { params }).then(({ data }) => setPrayers(data.prayers)).finally(() => setLoading(false));
  };
  useEffect(load, [status]);

  return (
    <div className="max-w-4xl mx-auto px-6 md:px-10 py-20">
      <p className="mono-label mb-4">The Register</p>
      <h1 className="font-heading text-4xl md:text-5xl text-ink leading-none">Answered Prayer Register</h1>
      <p className="font-body text-lg text-ink-secondary mt-6 leading-relaxed max-w-2xl">
        An archive rather than a feed. Each entry carries a sequential Ministry reference number. Some answers arrived as certainty; others simply as an opening.
      </p>

      <div className="flex flex-wrap gap-4 items-end mt-10 paper-rule pt-8">
        <div>
          <span className="mono-label block mb-2">Search</span>
          <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
            className="bg-transparent border border-ink/25 px-3 py-2 font-body text-ink focus:border-ink outline-none" data-testid="register-search" />
        </div>
        <div>
          <span className="mono-label block mb-2">Status</span>
          <select value={status} onChange={(e) => setStatus(e.target.value)} className="bg-transparent border border-ink/25 px-3 py-2 font-body text-ink outline-none" data-testid="register-status">
            <option value="">All</option>
            {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <button onClick={load} className="btn-ink" data-testid="register-apply">Apply</button>
      </div>

      {loading ? (
        <p className="mono-label mt-16">Attending…</p>
      ) : (
        <div className="mt-12 space-y-px bg-ink/15 border border-ink/15">
          {prayers.map((p) => (
            <article key={p.id} className={`bg-paper p-8 md:p-10 ${p.featured ? "border-l-4 border-terracotta" : ""}`} data-testid={`register-${p.id}`}>
              <div className="flex items-baseline justify-between gap-4 mb-4 flex-wrap">
                <span className="mono-label text-ink">Prayer No. {String(p.prayer_number || 0).padStart(6, "0")}</span>
                <span className="stamp">{p.status}</span>
              </div>
              <div className="flex items-baseline justify-between gap-4">
                <h2 className="font-heading text-3xl text-ink">{p.display_name}</h2>
                {p.location && <span className="mono-label">{p.location}</span>}
              </div>
              <p className="font-body text-lg text-ink-secondary mt-4 leading-relaxed">{p.excerpt}</p>
              {p.answer_text && (
                <div className="mt-6 border-l-2 border-terracotta pl-5">
                  <span className="mono-label block mb-2">The answer</span>
                  <p className="font-body text-lg text-ink italic leading-relaxed">{p.answer_text}</p>
                </div>
              )}
              <div className="mono-label mt-6 flex gap-6 flex-wrap">
                <span>Submitted {p.created_at ? new Date(p.created_at).toLocaleDateString() : "—"}</span>
                {p.answered_at && <span>Acknowledged {new Date(p.answered_at).toLocaleDateString()}</span>}
              </div>
            </article>
          ))}
          {prayers.length === 0 && <div className="bg-paper p-12 text-center font-body text-ink-tertiary italic">No entries yet.</div>}
        </div>
      )}
    </div>
  );
}
